<template>
	<v-bottom-sheet class="responsive-mobile-banner" :model-value="bannerVisible" :scrim="false" persistent>
		<sk-card class="banner-card">
			<v-img class="mb-6" :aspect-ratio="1" :src="logo" height="32px" width="98" />
			<p v-html="$t('banners.responsive-mobile-message')" />
			<template #footer>
				<div class="d-flex flex-row justify-center w-100">
					<sk-primary-btn :text="$t('commons.cta.i-understand')" @click="hideMobileBanner" width="100%" />
				</div>
			</template>
		</sk-card>
	</v-bottom-sheet>
</template>

<style lang="scss">
//FIXME: why can't write this in a scope <style> with a :deep(.v-bottom-sheet__content) ?
.responsive-mobile-banner {
	.v-bottom-sheet__content {
		border-radius: var(--sk-border-radius-lg) var(--sk-border-radius-lg) 0 0 !important;
	}
}
</style>

<style scoped lang="scss">
.responsive-mobile-banner {
	.banner-card {
		border-radius: var(--sk-border-radius-lg) var(--sk-border-radius-lg) 0 0 !important;
		:deep(.sk-card-body),
		:deep(.sk-card-footer) {
			padding-left: var(--sk-spacing-sm) !important;
			padding-right: var(--sk-spacing-sm) !important;
		}

		:deep(.sk-card-footer) {
			border-radius: 0;
		}
	}
}
</style>

<script setup lang="ts">
import { computed } from 'vue';
import { VBottomSheet, VImg } from 'vuetify/components';

import { SkPrimaryBtn } from '@silae/components/buttons';
import { SkCard } from '@silae/components/containers';
import { useTheme } from '@silae/composables/ui';
import logoBlue from '~/assets/logo-blue.svg';
import logoWhite from '~/assets/logo-white.svg';
import { useResponsive } from '~/composables';

/** Composables and computed */
const { bannerVisible, hideMobileBanner } = useResponsive();
const { isDark } = useTheme();

const logo = computed(() => (isDark.value ? logoWhite : logoBlue));
</script>
